import React, { Component } from 'react';
import InlineSVG from 'svg-inline-react';

import Button from 'components/Button';
import Input from 'components/Input';
import Gear from '../../../assets/icons/gear';
import Plus from '../../../assets/icons/plus';
import IndentRight from '../../../assets/icons/arrow-indent-right';
import RemoveIcon from '../../../assets/icons/minus-circle';

import '../../../sass/components/ui-list';

export default class ClassroomPanelListItem extends Component {

	render () {

		let product = this.props.products.find( (product)=> {
			return product.productId === this.props.classroom.product;
		});


		return (
			<div className="list-row">
				<div className="list-row">
					{/* classroom title */}
					<div className="list-cell">
						<span>{this.props.classroom.name}</span>
					</div>
					{/* teacher */}
					<div className="list-cell">
						<span>{this.props.teacher ? this.props.teacher.email : ''}</span>
					</div>
					{/* products */}
					<div className="list-cell">
						<span>{product.name}</span>
					</div>
					{/* students */}
					<div className="list-cell qty align-right">
						<span>{this.props.classroom.studentCount}</span>
					</div>
					<div className="list-cell no-grow no-left-pad">
						<Button
							tooltipText="Remove"
							tooltipPosition="left"
							icon={RemoveIcon}
							onClick={this.props.deleteClassroom.bind(this, this.props.classroom)}
							buttonClass="circle transparent tiny hover-red"
						/>
					</div>
				</div>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./js/components/ClassroomPanelList/ClassroomPanelListItem.js